import { isAxiosError } from "axios";

export const CONNECT_API_V1_BASE_URL: string =
  import.meta.env?.VITE_CONNECT_API_V1_URL ?? "";

export function gatewayUrl(
  siteId: string,
  ...segments: (string | number)[]
): string {
  return [CONNECT_API_V1_BASE_URL, siteId, ...segments].join("/");
}

export function buildUpdateMask(payload: object): string {
  return Object.entries(payload)
    .filter(([, value]) => value !== undefined)
    .map(([key]) => key)
    .join(",");
}

export function withUpdateMask(url: string, payload: object): string {
  const mask = buildUpdateMask(payload);
  if (!mask) return url;
  const params = new URLSearchParams({ update_mask: mask });
  return `${url}?${params.toString()}`;
}

export function updateMaskParam(updateMask: string[]): URLSearchParams {
  if (updateMask.length === 0) {
    throw new Error("updateMask must include at least one field");
  }
  return new URLSearchParams({ update_mask: updateMask.join(",") });
}

export function emptyToUndefined(
  value: string | null | undefined,
): string | undefined {
  return value ? value : undefined;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

const GRPC_CODE_ALREADY_EXISTS = 6;

export function isAlreadyExistsError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  if (error.response?.status === 409) return true;

  const data: unknown = error.response?.data;
  if (!isRecord(data)) return false;

  if (data.code === GRPC_CODE_ALREADY_EXISTS) return true;

  if (
    typeof data.message === "string" &&
    data.message.toLowerCase().includes("already exists")
  ) {
    return true;
  }

  return Object.values(data).some(
    (value) =>
      Array.isArray(value) &&
      value.some(
        (entry) =>
          typeof entry === "string" &&
          entry.toLowerCase().includes("already exists"),
      ),
  );
}

const GRPC_CODE_FAILED_PRECONDITION = 9;

export function isFailedPreconditionError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  if (error.response?.status === 412) return true;
  const data: unknown = error.response?.data;
  return isRecord(data) && data.code === GRPC_CODE_FAILED_PRECONDITION;
}
